exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.model-card[data-v-70d58c62]:hover {\n  text-decoration: none;\n}\n.card-text[data-v-70d58c62] {\n  color: #676868;\n}\n.cursor-pointer[data-v-70d58c62]{\n  cursor: pointer;\n}\n\n/* 11 clears CarImageRotator's internal layers (10 = arrows/dots, 9 = duplicate frame) */\n.model-card__badge-row[data-v-70d58c62] {\n  z-index: 11;\n  flex-wrap: wrap;\n}\n", ""]);

// exports
